import React from 'react';
import { useIsNonInteractiveViewer } from '@app/ui';
import { SearchBoxSite } from '@app/catalog';
import { NavBarSearchWrapper } from './SearchBox.styles';

const SearchBox = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();

  if (isNonInteractiveViewer) {
    return null;
  }

  return (
    <NavBarSearchWrapper className="navbar-search">
      <SearchBoxSite />
    </NavBarSearchWrapper>
  );
};

export default SearchBox;
